import { useEffect, useRef } from 'react';
import { isStop } from '@atlassian/experience-tracker';
export var useSetUpExperience = function useSetUpExperience(_ref) {
  var experienceTracker = _ref.experienceTracker,
    contentId = _ref.contentId,
    spaceKey = _ref.spaceKey,
    experience = _ref.experience,
    ccExperience = _ref.ccExperience;
  var idRef = useRef();
  var ccExperienceStartedRef = useRef(false);
  var id = "".concat(spaceKey, "-").concat(contentId);

  /**
   * Start experience as close to the user action as possible.
   * Our approximation is component's first render.
   *
   * Addition to starting experience on first render, embedding products may do SPA transition e.g. view different contents without remounting component.
   * We need to re-start experience if `contentId` or `spaceKey` has changed.
   * In this case, experience will abort the current ongoing one and start a new experience (by checking experience id)
   */
  if (idRef.current !== id) {
    experienceTracker.start({
      name: experience,
      id: id,
      collect: function collect(events, experience) {
        if (events.find(function (event) {
          return event.action === 'taskStart' && event.name === ccExperience && event.id === contentId;
        })) {
          ccExperienceStartedRef.current = true;
        }

        /**
         * We have experience forwarding from confluence-frontend
         * With the forwarding experience set up, EP experience will be concluded following CC experience, either "succeed", "fail" or "abort"
         */
        experience.stopOn(events.find(function (event) {
          return isStop(event) && event.name === ccExperience && event.id === contentId;
        }));
      }
    });
    idRef.current = id;
  }
  useEffect(function () {
    return function () {
      /**
       * User can navigates away (EP component unmount) before CC experience started
       * In this case, we want to abort EP experience as the conclusion.
       */
      if (idRef.current && !ccExperienceStartedRef.current) {
        experienceTracker.abort({
          name: experience,
          reason: 'User navigated away before starting to load'
        });
      }
    };
  }, [experienceTracker, experience]);
};